/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateReflectionEventCommand } from '../model/createReflectionEventCommand';
import { CreateReflectionEventCommandResult } from '../model/createReflectionEventCommandResult';
import { DeleteReflectionEventCommandResult } from '../model/deleteReflectionEventCommandResult';
import { GetReflectionEventQueryResult } from '../model/getReflectionEventQueryResult';
import { GetReflectionEventStatisticsQueryResult } from '../model/getReflectionEventStatisticsQueryResult';
import { GetReflectionEventsQueryResult } from '../model/getReflectionEventsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { UpdateReflectionEventCommand } from '../model/updateReflectionEventCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReflectionEventsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param startDateTimeLocal 
     * @param endDateTimeLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reflectionEventsGet(startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetReflectionEventsQueryResult>;
    public reflectionEventsGet(startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReflectionEventsQueryResult>>;
    public reflectionEventsGet(startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReflectionEventsQueryResult>>;
    public reflectionEventsGet(startDateTimeLocal?: string, endDateTimeLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateTimeLocal !== undefined && startDateTimeLocal !== null) {
            queryParameters = queryParameters.set('StartDateTimeLocal', <any>startDateTimeLocal);
        }
        if (endDateTimeLocal !== undefined && endDateTimeLocal !== null) {
            queryParameters = queryParameters.set('EndDateTimeLocal', <any>endDateTimeLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetReflectionEventsQueryResult>('get',`${this.basePath}/ReflectionEvents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reflectionEventsPost(body?: CreateReflectionEventCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateReflectionEventCommandResult>;
    public reflectionEventsPost(body?: CreateReflectionEventCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateReflectionEventCommandResult>>;
    public reflectionEventsPost(body?: CreateReflectionEventCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateReflectionEventCommandResult>>;
    public reflectionEventsPost(body?: CreateReflectionEventCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateReflectionEventCommandResult>('post',`${this.basePath}/ReflectionEvents`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param startDateLocal 
     * @param endDateLocal 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reflectionEventsStatisticsUidGet(uid: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetReflectionEventStatisticsQueryResult>;
    public reflectionEventsStatisticsUidGet(uid: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReflectionEventStatisticsQueryResult>>;
    public reflectionEventsStatisticsUidGet(uid: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReflectionEventStatisticsQueryResult>>;
    public reflectionEventsStatisticsUidGet(uid: string, startDateLocal?: string, endDateLocal?: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling reflectionEventsStatisticsUidGet.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateLocal !== undefined && startDateLocal !== null) {
            queryParameters = queryParameters.set('StartDateLocal', <any>startDateLocal);
        }
        if (endDateLocal !== undefined && endDateLocal !== null) {
            queryParameters = queryParameters.set('EndDateLocal', <any>endDateLocal);
        }
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('TimeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetReflectionEventStatisticsQueryResult>('get',`${this.basePath}/ReflectionEvents/Statistics/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reflectionEventsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteReflectionEventCommandResult>;
    public reflectionEventsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteReflectionEventCommandResult>>;
    public reflectionEventsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteReflectionEventCommandResult>>;
    public reflectionEventsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling reflectionEventsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteReflectionEventCommandResult>('delete',`${this.basePath}/ReflectionEvents/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param timeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reflectionEventsUidGet(uid: string, timeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<GetReflectionEventQueryResult>;
    public reflectionEventsUidGet(uid: string, timeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReflectionEventQueryResult>>;
    public reflectionEventsUidGet(uid: string, timeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReflectionEventQueryResult>>;
    public reflectionEventsUidGet(uid: string, timeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling reflectionEventsUidGet.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (timeZone !== undefined && timeZone !== null) {
            queryParameters = queryParameters.set('timeZone', <any>timeZone);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetReflectionEventQueryResult>('get',`${this.basePath}/ReflectionEvents/${encodeURIComponent(String(uid))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reflectionEventsUidPut(uid: string, body?: UpdateReflectionEventCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public reflectionEventsUidPut(uid: string, body?: UpdateReflectionEventCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public reflectionEventsUidPut(uid: string, body?: UpdateReflectionEventCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public reflectionEventsUidPut(uid: string, body?: UpdateReflectionEventCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling reflectionEventsUidPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/ReflectionEvents/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
